export interface ChatHubMessage {
  groupId: string;
  senderId: string;
  senderName: string;
  message: string | null;
  imagePath: string | null;
  patientId: string | null;
  sentAt: Date;
  doctorIds: string[] | null;
  patientName: string | null;
  chatMessageType?: number;
  woundConsultationId?: string | null;
  requiresRefresh?: boolean;
}

export enum ConnectionState {
  Connected = 'Connected',
  Disconnected = 'Disconnected',
  Reconnecting = 'Reconnecting',
  Error = 'Error',
}
